var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.833 14.0545C11.833 13.4651 12.0672 12.8998 12.484 12.483C12.9008 12.0662 13.4661 11.832 14.0555 11.832H21.2772C21.569 11.832 21.858 11.8895 22.1277 12.0012C22.3973 12.1129 22.6423 12.2766 22.8487 12.483C23.0551 12.6894 23.2188 12.9344 23.3305 13.204C23.4422 13.4737 23.4997 13.7627 23.4997 14.0545V21.2762C23.4997 21.5681 23.4422 21.8571 23.3305 22.1267C23.2188 22.3964 23.0551 22.6414 22.8487 22.8477C22.6423 23.0541 22.3973 23.2178 22.1277 23.3295C21.858 23.4412 21.569 23.4987 21.2772 23.4987H14.0555C13.7636 23.4987 13.4746 23.4412 13.205 23.3295C12.9353 23.2178 12.6903 23.0541 12.484 22.8477C12.2776 22.6414 12.1139 22.3964 12.0022 22.1267C11.8905 21.8571 11.833 21.5681 11.833 21.2762V14.0545Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34333 19.9475C9.0875 19.8021 8.87471 19.5916 8.72658 19.3374C8.57846 19.0832 8.50028 18.7942 8.5 18.5V10.1667C8.5 9.25 9.25 8.5 10.1667 8.5H18.5C19.125 8.5 19.465 8.82083 19.75 9.33333",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copyIcon.0d875de91656a445f6e662d427051ea8.svg";